import { Link } from '@tanstack/react-router';

export function LandingPage() {
  return (
    <main className="max-w-2xl mx-auto px-6 py-16 sm:py-24">
      <h1 className="text-4xl sm:text-5xl font-semibold text-brand-primary mb-6">Ballast</h1>
      <p className="text-xl text-brand-body mb-8 leading-relaxed">
        Stable payments at your counter. Accept USDC alongside cards — no chargebacks, settled to
        your bank next business day.
      </p>
      <Link
        to="/onboarding/start"
        className="inline-block bg-brand-accent hover:brightness-95 text-white px-8 py-3 rounded-md font-medium transition"
      >
        Get started
      </Link>
      <p className="text-sm text-brand-muted mt-8">
        Application code lives in <code>/app/</code>. Marketing site at{' '}
        <a className="underline" href="https://ballastpay.com">
          ballastpay.com
        </a>
        .
      </p>
    </main>
  );
}
